import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { GenericTileModule } from '../generic-tile/generic-tile.module';
import { LiveClassCarouselBannersComponent } from '../live-class-carousel-banners/live-class-carousel-banners.component';
import { LiveClassPcPromoModalComponent } from '../live-class-pc-promo-modal/live-class-pc-promo-modal.component';
import { LiveClassRevampModule } from '../live-class-revamp/live-class-revamp.module';
import { LiveClassSharedModule } from '../live-class-shared/live-class-shared.module';
import { LiveClassUnavailable } from '../live-class-unavailable/live-class-unavailable.component';
import { MktBannerComponent } from '../mkt-banner/mkt-banner.component';
import { ZoomBannerComponent } from '../zoom-banner/zoom-banner.component';
import { LiveClassSectionComponent } from './live-class-section.component';

@NgModule({
  imports: [CommonModule, SharedModule, GenericTileModule, LiveClassRevampModule, LiveClassSharedModule],
  declarations: [
    LiveClassSectionComponent,
    LiveClassCarouselBannersComponent,
    LiveClassPcPromoModalComponent,
    LiveClassUnavailable,
    ZoomBannerComponent,
    MktBannerComponent,
  ],
  exports: [LiveClassSectionComponent],
  entryComponents: [LiveClassPcPromoModalComponent],
})
export class LiveClassSectionModule {}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-section/live-class-section.module.ts